import React, { useContext } from 'react'
import ContMessageI18N from './ContMessageI18N';
import ContTestContext from './ContTestContext';
import ContTestVehicle from './ContTestVehicle';
import ContTestVehiclesConfig from './ContTestVehiclesConfig';
import ContTestVehiclesStock from './ContTestVehiclesStock';
import ContTestOptionsAvailable from './ContTestOptionsAvailable';
import ContTestAccessoriesAvailable from './ContTestAccessoriesAvailable';
import ContTestPartExchange from './ContTestPartExchange';
import ContTestParameters from './ContTestParameters';
import ContTestJson from './ContTestJson';
import HelperContext from '../helpers/HelperContext';
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setVehicleDescriptionType, setVehicleExamples, setSettingLanguage } from '../actions/actionsAppTest';
import {
    fetchSimulationVehicleDetailsIfNeeded, fetchSimulationVehiclesIfNeeded, fetchSimulationAccessoriesIfNeeded, fetchSimulationOptionsIfNeeded
} from '../actions/actionsApiSimulation';
import TestToolBar from '../components/testCriteria/TestToolBar';

export default function ContTestCriteria() {
    const globalstate = useContext(ReducerContext);
    const dispatch = useContext(ReducerDispatchContext);

    function onChangeVehicleDescriptionType(value) {
        const perimeterFilter = globalstate.settings.perimeterFilter;
        dispatch(setVehicleDescriptionType(value, perimeterFilter))
        const siteCode = HelperContext.getAppliedSiteCode(globalstate.testCriteria.context.siteCode, perimeterFilter, value,
            globalstate.testCriteria.context.countryCode, globalstate.testCriteria.context.distributionBrand)
        const journeyType = HelperContext.adjustJourneyType(perimeterFilter,
            globalstate.testCriteria.context.customer.clientType,
            siteCode, globalstate.testCriteria.context.journeyType);
        const newContext = { ...globalstate.testCriteria.context, siteCode: siteCode, journeyType: journeyType }
        dispatch(setVehicleExamples(newContext, { ...globalstate.settings, vehDescType: value }))
        fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, { context: newContext }, null, true);
        fetchSimulationVehiclesIfNeeded(globalstate, dispatch, { context: newContext }, null, null, null, true);
    }

    function onForce() {
        fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {}, null, true);
        fetchSimulationOptionsIfNeeded(globalstate, dispatch, {}, null, null, true);
        fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {}, null, null, true);
        fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {}, null, null, null, true);
        dispatch(setVehicleExamples(globalstate.testCriteria.context, globalstate.settings));
    }
    function onChangeLanguage(language, contextLanguage) {
        dispatch(setSettingLanguage(language, contextLanguage));
      }

    function getMessage(i18nKey) {
        return <ContMessageI18N i18n={i18nKey} />
    }

    return (
        <React.Fragment>
            <TestToolBar
                onChangeVehicleDescriptionType={onChangeVehicleDescriptionType}
                onForce={onForce}
                onChangeLanguage={onChangeLanguage}
                settings={globalstate.settings}
                context={globalstate.testCriteria.context}
            />
            <div className="accordion" id="accordionCriteria">
                <div className="accordion-item">
                    <h6 className="accordion-header" id="headingCriteriaContext" >
                        <button className="accordion-button collapseCriteriaButton" type="button"
                            data-bs-toggle="collapse" data-bs-target="#collapseCriteriaContext" aria-expanded="false"
                            aria-controls="collapseCriteriaContext">
                            {getMessage('testpage.section.context')}
                        </button>
                    </h6>
                    <div id="collapseCriteriaContext" className="accordion-collapse collapse collapseCriteria"
                        aria-labelledby="headingCriteriaContext"  >
                        <div className="accordion-body">
                            <ContTestContext />
                        </div>
                    </div>
                </div>
                {globalstate.settings.process !== 'vehiclesConfig' && globalstate.settings.process !== 'vehiclesStock'
                    && globalstate.settings.process !== 'vehiclesDefault'
                    && <div className="accordion-item">
                        <h6 className="accordion-header" id="headingCriteriaVehicle" >
                            <button className="accordion-button collapseCriteriaButton" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseCriteriaVehicle" aria-expanded="false" aria-controls="collapseCriteriaVehicle">
                                {getMessage('testpage.section.vehicle')}
                            </button>
                        </h6>
                        <div id="collapseCriteriaVehicle" className="accordion-collapse collapse collapseCriteria"
                            aria-labelledby="headingCriteriaVehicle"  >
                            <div className="accordion-body">
                                <ContTestVehicle />
                            </div>
                        </div>
                    </div>
                }
                {globalstate.settings.process === 'vehiclesConfig'
                    && <div className="accordion-item">
                        <h6 className="accordion-header" id="headingCriteriaVehiclesConfig" >
                            <button className="accordion-button collapseCriteriaButton" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseCriteriaVehiclesConfig" aria-expanded="false"
                                aria-controls="collapseCriteriaVehiclesConfig">
                                {getMessage('testpage.section.vehicles')}
                            </button>
                        </h6>
                        <div id="collapseCriteriaVehiclesConfig" className="accordion-collapse collapse collapseCriteria"
                            aria-labelledby="headingCriteriaVehiclesConfig"  >
                            <div className="accordion-body">
                                <ContTestVehiclesConfig />
                            </div>
                        </div>
                    </div>
                }
                {(globalstate.settings.process === 'vehiclesStock' || globalstate.settings.process === 'vehiclesDefault')
                    && <div className="accordion-item">
                        <h6 className="accordion-header" id="headingCriteriaVehiclesStock" >
                            <button className="accordion-button collapseCriteriaButton" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseCriteriaVehiclesStock" aria-expanded="false"
                                aria-controls="collapseCriteriaVehiclesStock">
                                {getMessage('testpage.section.vehicles')}
                            </button>
                        </h6>
                        <div id="collapseCriteriaVehiclesStock" className="accordion-collapse collapse collapseCriteria"
                            aria-labelledby="headingCriteriaVehiclesStock"  >
                            <div className="accordion-body">
                                <ContTestVehiclesStock />
                            </div>
                        </div>
                    </div>
                }
                {globalstate.settings.process === 'options'
                    && <div className="accordion-item">
                        <h6 className="accordion-header" id="headingCriteriaOptions" >
                            <button className="accordion-button collapseCriteriaButton" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseCriteriaOptions" aria-expanded="false" aria-controls="collapseCriteriaOptions">
                                {getMessage('testpage.section.availableOptions')}
                            </button>
                        </h6>
                        <div id="collapseCriteriaOptions" className="accordion-collapse collapse collapseCriteria"
                            aria-labelledby="headingCriteriaOptions"  >
                            <div className="accordion-body">
                                <ContTestOptionsAvailable />
                            </div>
                        </div>
                    </div>
                }
                {globalstate.settings.process === 'accessories'
                    && <div className="accordion-item">
                        <h6 className="accordion-header" id="headingCriteriaAccessories" >
                            <button className="accordion-button collapseCriteriaButton" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseCriteriaAccessories" aria-expanded="false"
                                aria-controls="collapseCriteriaAccessories">
                                {getMessage('testpage.section.availableAccessories')}
                            </button>
                        </h6>
                        <div id="collapseCriteriaAccessories" className="accordion-collapse collapse collapseCriteria"
                            aria-labelledby="headingCriteriaAccessories"  >
                            <div className="accordion-body">
                                <ContTestAccessoriesAvailable />
                            </div>
                        </div>
                    </div>
                }
                {globalstate.testCriteria.parameters && Object.keys(globalstate.testCriteria.parameters).length > 0
                    && <div className="accordion-item">
                        <h6 className="accordion-header" id="headingCriteriaParameters" >
                            <button className="accordion-button collapseCriteriaButton" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseCriteriaParameters" aria-expanded="false" aria-controls="collapseCriteriaParameters">
                                {getMessage('testpage.section.parameters')}
                            </button>
                        </h6>
                        <div id="collapseCriteriaParameters" className="accordion-collapse collapse collapseCriteria"
                            aria-labelledby="headingCriteriaParameters"  >
                            <div className="accordion-body">
                                <ContTestParameters />
                            </div>
                        </div>
                    </div>
                }
                {globalstate.settings.process !== 'vehiclesConfig' && globalstate.settings.process !== 'vehiclesStock'
                    && globalstate.settings.process !== 'vehiclesDefault' && globalstate.settings.process !== 'options'
                    && globalstate.settings.process !== 'accessories'
                    && <div className="accordion-item">
                        <h6 className="accordion-header" id="headingCriteriaPartExchange" >
                            <button className="accordion-button collapseCriteriaButton" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseCriteriaPartExchange" aria-expanded="false"
                                aria-controls="collapseCriteriaPartExchange">
                                {getMessage('testpage.section.partExchange')}
                            </button>
                        </h6>
                        <div id="collapseCriteriaPartExchange" className="accordion-collapse collapse collapseCriteria"
                            aria-labelledby="headingCriteriaPartExchange"  >
                            <div className="accordion-body">
                                <ContTestPartExchange />
                            </div>
                        </div>
                    </div>
                }
                <div className="accordion-item">
                        <h6 className="accordion-header" id="headingCriteriaJsonParameters" >
                            <button className="accordion-button collapseCriteriaButton" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseCriteriaJsonParameters" aria-expanded="false"
                                aria-controls="collapseCriteriaJsonParameters">
                                {getMessage('testpage.section.jsonParameters')}
                            </button>
                        </h6>
                        <div id="collapseCriteriaJsonParameters" className="accordion-collapse collapse collapseCriteria"
                            aria-labelledby="headingCriteriaJsonParameters"  >
                            <div className="accordion-body">
                                <ContTestJson />
                            </div>
                        </div>
                    </div>
            </div>
        </React.Fragment>
    );
}
